import { useRuntimeConfig } from '#app'
import * as Sentry from '@sentry/nuxt'
import { toNumber } from '@vue/shared'

Sentry.init({
  dsn: useRuntimeConfig().public.sentry.dsn,
  environment: useRuntimeConfig().public.service.environment,
  release: useRuntimeConfig().public.sentry.release,
  integrations: [
    Sentry.browserSessionIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.captureConsoleIntegration({
      levels: ['warn', 'error', 'assert'],
    }),
    Sentry.contextLinesIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.extraErrorDataIntegration(),
    Sentry.httpClientIntegration(),
    Sentry.piniaIntegration(usePinia()),
    Sentry.vueIntegration({
      tracingOptions: {
        trackComponents: true,
        hooks: ['mount', 'unmount'],
      },
    }),
  ],
  tracePropagationTargets: ['localhost', window.location.origin],
  sampleRate: toNumber(useRuntimeConfig().public.sentry.sampleRate),
  sendDefaultPii: true,
  tracesSampleRate: toNumber(useRuntimeConfig().public.sentry.tracesSampleRate),
  profilesSampleRate: toNumber(useRuntimeConfig().public.sentry.profilesSampleRate),
  replaysOnErrorSampleRate: toNumber(useRuntimeConfig().public.sentry.replaysOnErrorSampleRate),
  replaysSessionSampleRate: toNumber(useRuntimeConfig().public.sentry.replaysSessionSampleRate),
})
